/**
 * @author czy
 * 功能：返利规则列表
 */

import { Service } from '@/tools'

export class RebateRuleService<T extends TSettle.RebateRule> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TSettle.RebateRule}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 查询返利规则列表 /api/settle/rebateRule/v1/page
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  // 返利规则新增 /api/settle/rebateRule/v1/add
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)

  // 返利规则修改 /api/settle/settleRebatePool/v1/edit
  update = <K extends T['ApiEdit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiEdit', data)

  // 返利规则提交 /api/settle/settleRebatePool/v1/edit
  submit = <K extends T['ApiSubmit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSubmit', data)

  // 返利规则详情 /api/settle/settleRebatePool/v1/queryById
  detail = <K extends T['ApiDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDetail', data)

  // 返利规则删除 /api/settle/settleRebatePool/v1/deleteById
  deleteById = <K extends T['ApiDeleteById']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteById', data)

  // 返利规则终止 /api/settle/settleRebatePool/v1/terminate
  terminate = <K extends T['ApiTerminate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiTerminate', data)

  // 返利规则变更 /api/settle/settleRebatePool/v1/change
  change = <K extends T['ApiChange']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiChange', data)
}
